import axios from "axios";
import { store } from "../store/store";
import { doLogout } from "../store/globalSlice";
import t  from "../languages/es/global.json"
import { CODE_AUTH_EXPIRED, CODE_MULTI_FACTOR_AUTH } from "./globalConstants";


export async function apiFetch({
  method,
  url, 
  data, 
  body = false, 
  contentType = "application/json",
  headerParams = true,
  api = process.env.REACT_APP_API,
  originApp = false
  }) {
  const lang = localStorage.getItem("language")
  const token = localStorage.getItem("token")
  const user = JSON.parse(localStorage.getItem("user"))
  const header = {
      "Content-Type": contentType,
      ...(headerParams ? {
      'Authorization': token ? 'Bearer ' + token : '',
      ...(originApp ? { "originApp": process.env.REACT_APP_ORIGIN_APP } : { 'originUser': user?.nickName }),
      "Accept-Language": lang
      } : {})
    }

  try {
    let response
    response = await axios({
      method: method,
      url: api+url,
      ...body ? { data: data } : { params: data },
      headers: header,
    });

    if (response.data) {
      return response.data;
    }
  } catch (error) {

    if(error.code === "ERR_NETWORK" || error.code === 403){
      store.dispatch(doLogout())
      const axiosError = {
        response: error.name,
        message: error.message
      }
      return axiosError
    }
    if (error.response) {
      if (error.response.status === 422) {
        store.dispatch(doLogout());
        return {
          response: error.code,
          message: error.response.data.message
        };
      }
      if (error.response.status === 404) {
        window.location.href = "/not-found";
      }
      if(error.response.status === 409){
        return {
          response: error.name,
          message:error.response.data.message
        }
      }
      if(error.response.status === 401){
        store.dispatch(doLogout());
        return {
          response: error.code,
          message: error.response.data.message
        };
      }
      if (error.response.status === 422 || error.response.status === 401) {
        store.dispatch(doLogout())
        return {
          response: error.code,
          message: error.response.data.message === "token.invalidExpired" ? t.errors.tokenExpired : error.response.data.message
        };
      }
      if (error.response.status === 400 && data.message.includes(CODE_MULTI_FACTOR_AUTH)){
        return {
          response: error.code,
          message: t.errors.multiFactorAuth
        };
      }
      if (error.response.status === 400 && data.message.includes(CODE_AUTH_EXPIRED)){
        const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
        return {
          response: error.code,
          message: t.errors.codeAuthExpired
        };
      }
    }
    return error
  }
}